import React from "react";
import { Link } from "react-router-dom";
import "../styles/NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">Oops! The page you're looking for doesn't exist.</p>
        <div className="not-found-links">
          <Link to="/" className="btn">
            Go Back Home
          </Link>
          <Link to="https://discord.rixxymc.fun/" target="_blank" className="btn discord-btn">
            Join our Discord
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
